/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { useSelector } from 'react-redux';
import TargetingOngoingPlacementsDirectBuy from '../placementsSection/TargetingOngoingPlacementsDirectBuy';
import TargetingOngoingLocations from '../locationSection/TargetingOngoingLocations';
import TargetingOngoingLanguages from '../languagesSection/TargetingOngoingLanguages';
import TargetingOngoingDevicesOS from '../devicesOSSection/osVersions/TargetingOngoingDevicesOS';
import TargetingOngoingBrandsModels from '../devicesOSSection/brandsModels/TargetingOngoingBrandsModels';
import TargetingOngoingCustomAudience from '../customAudienceSection/TargetingOngoingCustomAudience';
import { ExcludeRulesSection } from '../excludeRules/ExcludeRulesSection';
import { targetingPages, campaignEnvironment } from 'constants';
import { Separator, Tab as MyTab } from 'components';

const DevicesOsPage = () => {
  const isWebsite = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isWebsite,
  );

  return (
    <>
      <TargetingOngoingBrandsModels />
      {!isWebsite && <TargetingOngoingDevicesOS />}
    </>
  );
};

const LangLocPage = () => {
  return (
    <>
      <TargetingOngoingLocations />
      <TargetingOngoingLanguages />
    </>
  );
};

const pages = {
  [targetingPages.placements]: TargetingOngoingPlacementsDirectBuy,
  [targetingPages.locations_languages]: LangLocPage,
  [targetingPages.devices_os]: DevicesOsPage,
  [targetingPages.custom_audience]: TargetingOngoingCustomAudience,
  [targetingPages.exclude_rules]: ExcludeRulesSection,
};

const TargetingSectionTabs = ({ currentTab, setCurrentTab, environment }) => {
  const isOnBoarding = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isOnBoarding,
  );

  // let errorFlag = useSelector((state) => state.formErrorsCampaign.targeting);
  // const targetingError = useSelector((state) => state.targetingPlacements.targetingError);

  const ComponentToShow = pages[currentTab];

  return (
    <>
      <div style={{ display: 'flex', gap: '24px' }}>
        <MyTab
          hidden={isOnBoarding}
          onChange={setCurrentTab}
          value={targetingPages.placements}
          label='Placements'
          pressed={currentTab === targetingPages.placements}
        />
        <MyTab
          onChange={setCurrentTab}
          value={targetingPages.locations_languages}
          label='Locations & Languages'
          pressed={currentTab === targetingPages.locations_languages}
        />
        <MyTab
          onChange={setCurrentTab}
          value={targetingPages.devices_os}
          label='Devices & OS'
          pressed={currentTab === targetingPages.devices_os}
        />
        <MyTab
          hidden={isOnBoarding || environment === campaignEnvironment.new_empty}
          onChange={setCurrentTab}
          value={targetingPages.exclude_rules}
          label='Exclude Rules'
          pressed={currentTab === targetingPages.exclude_rules}
        />
        <MyTab
          hidden={isOnBoarding}
          onChange={setCurrentTab}
          value={targetingPages.custom_audience}
          label='Custom Audience'
          pressed={currentTab === targetingPages.custom_audience}
        />
      </div>
      <Separator />
      <ComponentToShow environment={environment} />
    </>
  );
};

export default memo(TargetingSectionTabs);
